import { render, staticRenderFns } from "./userSocialWorker.vue?vue&type=template&id=73cc0e50&scoped=true&"
import script from "./userSocialWorker.vue?vue&type=script&lang=js&"
export * from "./userSocialWorker.vue?vue&type=script&lang=js&"
import style0 from "./userSocialWorker.vue?vue&type=style&index=0&id=73cc0e50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cc0e50",
  null
  
)

export default component.exports